import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {

    return (
    <div>
      <Dialog
        open={props?.visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props?.title}</DialogTitle>
        <DialogActions>
          <Button onClick={()=>{
              props.close();
          }} style={{background: '#4f62dd', color: '#fff'}} >
            {props?.button ? props.button : "Close"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
